import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Controller,
  ControllerWrapper,
  FieldWrapper,
  FormFieldsContainer,
  Label,
  RegularField,
  useFormContext,
  useResponsive,
} from '@common-fe/common-fe';

import {
  ChangePasswordField,
  ChangePasswordForm,
} from '@/modules/user/components/ManageProfile/components/Security/security.types';

interface Props {
  editMode?: boolean;
}

const EnterNewPasswordFields: React.FC<Props> = ({ editMode }) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  const {
    control,
    formState: { errors },
  } = useFormContext<ChangePasswordForm>();

  return (
    <Box
      round="container1Round"
      background="canvas"
      pad={isMobile ? 'spacing16' : 'spacing24'}
      border={{ size: '1px', color: 'border1' }}
    >
      <FormFieldsContainer>
        <FieldWrapper>
          <Label name={ChangePasswordField.existingPassword}>{t('Existing password')}</Label>
          <ControllerWrapper errorText={errors?.[ChangePasswordField.existingPassword]?.message}>
            <Controller
              name={ChangePasswordField.existingPassword}
              control={control}
              render={({ field }) => (
                <RegularField
                  name={ChangePasswordField.existingPassword}
                  value={field.value}
                  onChange={field.onChange}
                  editMode={editMode}
                  placeholder={t('Enter an existing password')}
                  isError={!!errors?.[ChangePasswordField.existingPassword]?.message}
                  type={isMobile ? undefined : 'password'}
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>

        <FieldWrapper>
          <Label name={ChangePasswordField.newPassword}>{t('New password')}</Label>
          <ControllerWrapper errorText={errors?.[ChangePasswordField.newPassword]?.message}>
            <Controller
              name={ChangePasswordField.newPassword}
              control={control}
              render={({ field }) => (
                <RegularField
                  name={ChangePasswordField.newPassword}
                  value={field.value}
                  onChange={field.onChange}
                  editMode={editMode}
                  type="password"
                  placeholder={t('Choose a new password')}
                  isError={!!errors?.[ChangePasswordField.newPassword]?.message}
                  passwordHelper
                  {...(isMobile
                    ? { passwordHelperBottomPosition: true }
                    : { passwordHelperLeftPosition: true })}
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>

        <FieldWrapper>
          <Label name={ChangePasswordField.confirmNewPassword}>{t('Confirm new password')}</Label>
          <ControllerWrapper errorText={errors?.[ChangePasswordField.confirmNewPassword]?.message}>
            <Controller
              name={ChangePasswordField.confirmNewPassword}
              control={control}
              render={({ field }) => (
                <RegularField
                  name={ChangePasswordField.confirmNewPassword}
                  value={field.value}
                  onChange={field.onChange}
                  editMode={editMode}
                  placeholder={t('Confirm a new password')}
                  isError={!!errors?.[ChangePasswordField.confirmNewPassword]?.message}
                  type="password"
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>
      </FormFieldsContainer>
    </Box>
  );
};

export default EnterNewPasswordFields;
